import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { cloneDeep, find, isEmpty } from '@ubi-cell/core-utils';
import { Subscription } from 'rxjs';
import { CustomDomService } from 'libs/api/src/lib/services/custom-dom.service';
import { TopBarService } from '../top-bar.service';
import { SharedService } from 'libs/api/src/lib/services/shared.service';
@Component({
    selector: 'ubi-cell-top-bar-tag',
    templateUrl: './top-bar-tag.component.html',
    styleUrls: ['./top-bar-tag.component.scss'],
    standalone: false
})
export class TopBarTagComponent implements OnInit, OnDestroy {

  @Input() capabilityType = null;
  @Input() selectedAlertProductType: string = null;
  searchBy: string = '';
  tagList: any = [];
  isTagCreation: boolean = false;
  filterTagArray: any = [];
  isCheckBoxChecked: boolean = false;
  topBarSubscriber$: Subscription;
  topBarFilterSubscriber$: Subscription;
  removedFilter: any = [];
  filteredTagCapability = ['light','transformers','cameras_video', 'tilt_monitoring', 'power_quality_sustained', 'power_quality_momentary', 'power_quality_voltage', 'planning'];
  customHeight = '0px';
  displayCreateTagButton: boolean = false;
  isPowerQualityTemporalViewEnable: boolean = false;
  currentModeSelectionSub: Subscription;

  constructor(
    private topBarService: TopBarService,
    public _topBarConf: TopBarService,
    private customDomService: CustomDomService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.topBarSubscriber$ = this.topBarService?.currTopBarConfig.subscribe((element) => {
      if (!isEmpty(element)) {
        this.isTagCreation = element?.is_tag_creation;
      }
    });

    this.getTagList();
    this.displayCreateTagButton = ['power_quality_sustained', 'power_quality_momentary', 'power_quality_voltage'].includes(this.capabilityType) ? true : false;
    if(this.displayCreateTagButton){
      this.changeCurrentViewMode();
    }
  }

  getTagList() {
    this.tagList = [];
    this.tagList = this.topBarService?.tagListResponse?.code == '200' && this.topBarService?.tagListResponse?.data ? cloneDeep(this.topBarService?.tagListResponse['data']) : [];
    this.tagList.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    if (this.isTagCreation && this.tagList?.length) {
      this.topBarService?.selectedTagOnCreation.forEach(item => {
        let index = this.tagList.find(x => {
          if (x.id === item) {
            return x['selected'] = true;
          }
        });
      });

      let type = this.capabilityType == 'notifications' ? this.selectedAlertProductType : this.capabilityType;
      if(this.filteredTagCapability?.includes(type)) {
        this.topBarService?.selectedTagOnNodeStatus.forEach(item => {
          let index = this.tagList.find(tag => {
            if (tag.id === item) {
              tag['selected'] = true;
              tag['disabled'] = true;
                return tag;
            }
          });
        });
      }
    } else if (!this.isTagCreation && this.tagList?.length) {
      this.topBarService?.selectedTagOnNodeStatus.forEach(item => {
        let index = this.tagList.find(x => {
          if (x.id === item) {
            return x['selected'] = true;
          }
        });
      });
    }

  }

  onSelectTags(event, filter) {
    let selectedTag = find(this.tagList, { 'id': filter.id });

    if (selectedTag) {
      selectedTag.selected = event.checked;
    }

    if (!this.isTagCreation) {
      this.isCheckBoxChecked = true;
      if (selectedTag.selected) {
        this.filterTagArray.push(filter?.id);
      } else {
        this.removedFilter.push(filter?.id)
        var index = this.filterTagArray.indexOf(filter?.id);
        if (index !== -1) {
          this.filterTagArray.splice(index, 1);
        }
      }
    } else {
      if (selectedTag.selected) {
        this.topBarService?.selectedTagOnCreation.push(filter?.id);
      } else {
        var index = this.topBarService?.selectedTagOnCreation.indexOf(filter?.id);
        if (index !== -1) {
          this.topBarService?.selectedTagOnCreation.splice(index, 1);
        }
      }

      let paramObject = {
        event: event,
        filter: selectedTag
      }
      this.topBarService?.nodeSelection.next(paramObject);
    }
    let selectedObj = find(this.tagList, { 'selected': true });
    this.isCheckBoxChecked = isEmpty(selectedObj) ?  false : true;
  }

  doTagFilter() {
    this.isCheckBoxChecked = false;
    let updatedSelections = [...this.topBarService.selectedTagOnNodeStatus];

    // Remove tags that were unchecked
    this.removedFilter.forEach(tagId => {
        const index = updatedSelections.indexOf(tagId);
        if (index !== -1) {
            updatedSelections.splice(index, 1);
        }
    });

    // Add newly selected tags
    this.filterTagArray.forEach(tagId => {
        if (!updatedSelections.includes(tagId)) {
            updatedSelections.push(tagId);
        }
    });

    this.removedFilter = [];

    // Update the service with new selections
    this.topBarService.selectedTagOnNodeStatus = updatedSelections;
    this.topBarService?.addTagSelectionFilter.next(updatedSelections);

    
      this.getHeight();
    
  }

  getHeight() {
    this._topBarConf.getHightSubject.next(0);
    let divHeight = this.customDomService.getDivHeightById('filterHeight'); // Provide the div's id here
    this._topBarConf.getHightValue$.subscribe((res) => {
      // Delay the height calculation to ensure the DOM is ready
      setTimeout(() => {       
        if (divHeight !== null) {
          this.customHeight = `${divHeight - 23}px`;
        } else {
          this.customHeight = `0px`;
        }
        // You can now use this height for any logic in this component
      }, 100); // Adjust the timeout duration if needed
    });
  }

  navigateToCreateTagScreen() {
    this.sharedService.displayTagCreationScreen.next(true);
  }

  changeCurrentViewMode() {
    this.currentModeSelectionSub = this._topBarConf.currSelectedMode.subscribe(data => {
      this.isPowerQualityTemporalViewEnable = data?.action === 'temporal' ? true : false;
    });
  }

  ngOnDestroy() {
    if (!isEmpty(this.topBarService?.addTagSelectionFilter)) {
      this.topBarService?.addTagSelectionFilter.next(null);
    }

    if (!isEmpty(this.topBarService?.nodeSelection)) {
      this.topBarService?.nodeSelection.next(null);
    }

    if (this.topBarSubscriber$) {
      this.topBarSubscriber$.unsubscribe();
    }

    if (this.topBarFilterSubscriber$) {
      this.topBarFilterSubscriber$.unsubscribe();
    }

    if(this.currentModeSelectionSub){
      this.currentModeSelectionSub.unsubscribe();
    }
  }
}
